import { flattenDeep } from 'lodash';

import * as clientSearch from './clientSearch';
import * as document from './document';
import * as podcast from './podcast';
import * as dismissible from './dismissible';
import * as aiChat from './aiChat';

export const sagas = flattenDeep([
  ...document.sagas,
  ...clientSearch.sagas,
  ...podcast.sagas,
  ...dismissible.sagas,
  ...aiChat.sagas,
]);
